import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboardingMobileCongratulation as orgConfig } from 'org/configs/modules.config';
import checkmarkSVG from '../../../assets/images/checkmark_solid.svg';

/** @type {object} */
const defaultConfig = {
  defaults: {
    image: checkmarkSVG,
    congratulationsTitle: 'Congratulations',
    getCongratsText: (earnType) => (`You're ready to start shopping and earning ${earnType}.`),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
